import { useCallback, useEffect, useRef, useState } from "react";
import { Timer } from "@/components/Timer";
import { useCountdown } from "@/hooks/useCountdown";
import { countWords } from "@/lib/scoring";

const Counter = ({ n, ok, rule, testId }) => (
  <span data-testid={testId} className={`font-mono text-xs ${ok ? "text-emerald-600" : "text-amber-600"}`}>{n} words · {rule}</span>
);

export const SummaryItem = ({ part, item, onSubmit }) => {
  const [summary, setSummary] = useState("");
  const [opinion, setOpinion] = useState("");
  const ref = useRef({ summary: "", opinion: "" });
  const doneRef = useRef(false);
  const sumRef = useRef(null);

  const submit = useCallback(() => {
    if (doneRef.current) return;
    doneRef.current = true;
    onSubmit({ ...ref.current });
  }, [onSubmit]);

  useEffect(() => { sumRef.current?.focus(); }, []);
  const left = useCountdown(part.time, true, submit);
  const sw = countWords(summary), ow = countWords(opinion);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <h3 data-testid="summary-title" className="font-display text-2xl font-bold text-slate-900">{item.title}</h3>
        <Timer left={left} total={part.time} label="Section time" />
      </div>
      <p data-testid="summary-passage" className="rounded-xl bg-slate-50 p-5 leading-relaxed text-slate-700">{item.text}</p>
      <div className="space-y-2">
        <div className="flex items-center justify-between"><label className="text-sm font-semibold text-slate-800">Box 1 · Summary</label><Counter testId="summary-word-count" n={sw} ok={sw >= 25 && sw <= 50} rule="25–50 required" /></div>
        <textarea ref={sumRef} data-testid="summary-input" rows={4} value={summary}
          onChange={(e) => { ref.current.summary = e.target.value; setSummary(e.target.value); }}
          className="w-full rounded-lg border border-slate-300 p-4 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Summarize the main ideas in 25–50 words…" />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between"><label className="text-sm font-semibold text-slate-800">Box 2 · Your opinion</label><Counter testId="opinion-word-count" n={ow} ok={ow >= 50} rule="50+ required" /></div>
        <textarea data-testid="opinion-input" rows={6} value={opinion}
          onChange={(e) => { ref.current.opinion = e.target.value; setOpinion(e.target.value); }}
          className="w-full rounded-lg border border-slate-300 p-4 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Do you agree? Explain your view with reasons and examples (50+ words)…" />
      </div>
      <button data-testid="item-submit-btn" onClick={submit} className="rounded-full bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700">Submit section</button>
    </div>
  );
};
